import * as React from 'react';
import './ProductTitle.styles.less';
import { IProductTitleProps } from "./ProductTitle.types";

export const ProductTitle = (props: IProductTitleProps) => {
    const renderProductTitle = (title: string) => {
        // Replace hyphens with spaces before splitting
        const formattedTitle = title.replace(/-/g, ' - ');
        const titleArr = formattedTitle.split(' ');

        // Filter out empty strings that might result from multiple spaces
        const filteredTitleArr = titleArr.filter(word => word.trim() !== '');

        return filteredTitleArr.length > 0
            ? filteredTitleArr.map((word, i) =>
                <span key={i} className="title-word">{word}</span>
            )
            : <span>{title}</span>;
    };

    return <div className="ProductTitle">
            <div className={ !props.caption ? "product-title__title" : "product-title__title product-title__title--has-subtitle"}>
                <span className="product-title__title-border product-title__title-border--top product-title__title-border--bottom">
                    {renderProductTitle(props.title)}
                </span>
            </div>
            {props.caption &&
                <div className="product-title__caption">
                    <span>
                        {props.caption}
                    </span>
                </div>
            }
    </div>
}
